module.exports = __webpack_public_path__ + "img/hr-white-desert-bush-07.20fb2e41.png";